import {
  MediaResourceTypes,
  QuestionTypes,
} from '@showbie-socrative/socrative-utils';
import { schema } from 'normalizr';

export interface Quiz {
  id: number;
  version: number;
  createdById: number;
  isSharingEnabled: boolean;
  createdDate: string;
  lastUpdated: string;
  name: string;
  socNumber: string;
  parentId: number;
  questions: Array<string | number>;
  standard: QuizStandard;
  deleted: boolean;
}

export interface QuizQuestion {
  type: QuestionTypes;
  questionId: string | number;
  createdById: number;
  createdDate: Date;
  hasCorrectAnswer?: boolean;
  order: number;
  temporaryOrder?: number;
  questionImage?: ImageResource;
  questionVideo?: VideoResource;
  questionAudio?: AudioResource;
  questionText: string;
  explanation: string;
  explanationImage?: ImageResource;
  gradingWeight: number;
  answers: Array<string | number>;
  resources?: ImageResource[];
}

export interface Invalidation {
  description: string;
  title: string;
  meta?: string;
  inputIds?: string[];
}

export interface QuizAnswer {
  id: string | number;
  createdById: number;
  text: string;
  image?: ImageResource;
  isCorrect: boolean;
  order: number;
  questionId: string | number;
  resources: ImageResource[];
}

export interface AudioResource {
  id: string;
  url: string;
  type: MediaResourceTypes.Audio;
}

export interface VideoResource {
  id: string;
  url: string;
  type: MediaResourceTypes.Video;
  start?: number;
  end?: number;
  duration?: number;
  provider?: 'youtube' | 'vimeo';
}

export interface ImageResource {
  id: string | number;
  url: string;
  type: 'IM';
  urlXS?: string;
  urlS?: string;
  urlM?: string;
  urlL?: string;
  urlXL?: string;
}

export enum ImageResourceSizes {
  XXL = 1024,
  XL = 820,
  L = 600,
  M = 480,
  S = 320,
  XS = 160,
}

export interface QuizStandard {
  id: number;
  subjectId: number;
  coreId: number;
  gradeId: number;
  standardId: number;
  name: string;
  description: string;
  quizId: number;
}

export const QuizAnswerSchema = new schema.Entity('quizAnswer');
export const QuizQuestionSchema = new schema.Entity(
  'quizQuestion',
  { answers: [QuizAnswerSchema] },
  {
    idAttribute: 'questionId',
  }
);

export const QuizSchema = new schema.Entity(
  'quiz',
  { questions: [QuizQuestionSchema] },
  { idAttribute: 'id' }
);
